export default "__VITE_ASSET__DilfDDnb__"